import React from "react";
import PathListItem from "./PathListItem";

export default function CollectionSidebar({
  collectionId,
  collectionName,
  paths,
  selectedPathId,
  isDrawing,
  draftPointCount,
  isSaving,
  error,
  onStartDrawing,
  onUndoPoint,
  onCancelDrawing,
  onSavePath,
  onSelectPath,
  onRenamePath,
  onDeletePath,
  onMonitor,
  onViewRuns,
}) {
  return (
    <aside className="dc-sidebar">
      <div className="dc-brand">WUI-GO</div>
      <header>
        <p>Data collection</p>
        <h1>{collectionName || "Path collection"}</h1>
        <span className="dc-collection-id">ID: {collectionId}</span>
      </header>

      {error && <div className="dc-error">{error}</div>}

      {isDrawing ? (
        <section className="dc-drawing-card">
          <strong>Creating a new path</strong>
          <p>{draftPointCount < 2 ? "Add at least two points on the map." : draftPointCount >= 25 ? "25 points added. This is the API limit." : `${draftPointCount} points added. Ready to save.`}</p>
          <div className="dc-drawing-actions">
            <button type="button" onClick={onUndoPoint} disabled={!draftPointCount}>Undo point</button>
            <button type="button" onClick={onCancelDrawing}>Cancel</button>
          </div>
          <button className="dc-primary" type="button" disabled={draftPointCount < 2 || isSaving} onClick={onSavePath}>
            {isSaving ? "Saving…" : "Save path"}
          </button>
        </section>
      ) : (
        <button className="dc-primary dc-create" type="button" onClick={onStartDrawing}>＋ Create path</button>
      )}

      <div className="dc-list-heading">
        <h2>Saved paths</h2>
        {selectedPathId && <button type="button" onClick={() => onSelectPath(null)}>Show all</button>}
      </div>

      <div className="dc-path-list">
        {paths.length === 0 ? (
          <div className="dc-empty"><strong>No paths yet</strong><span>Create a path by placing points on the map.</span></div>
        ) : paths.map((path) => (
          <PathListItem
            key={path.id}
            path={path}
            isSelected={path.id === selectedPathId}
            onSelect={() => onSelectPath(path.id === selectedPathId ? null : path.id)}
            onRename={(name) => onRenamePath(path.id, name)}
            onDelete={() => onDeletePath(path.id)}
          />
        ))}
      </div>

      <button className="dc-monitor" type="button" disabled={!paths.length} onClick={onMonitor}>Monitor paths</button>
      <button className="dc-history" type="button" onClick={onViewRuns}>View monitoring runs</button>
    </aside>
  );
}
